module.exports = __webpack_public_path__ + "img/aboutUs-desc.8a3ac02a.png";